import React from 'react';
import { generateId } from '../../utils/accessibility';

interface FormFieldProps {
  label: string;
  children: React.ReactElement;
  error?: string;
  required?: boolean;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  children,
  error,
  required = false,
  className = '',
}) => {
  const id = generateId('field');

  // Clone the child element and add the id
  const childWithId = React.cloneElement(children, {
    id,
    'aria-describedby': error ? `${id}-error` : undefined,
    'aria-invalid': error ? 'true' : 'false',
  });

  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
      >
        {label} {required && '*'}
      </label>
      {childWithId}
      {error && (
        <p id={`${id}-error`} className="text-red-500 text-sm mt-1" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};
